(() => {
  const handle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
  const fileRoot = 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/';
  const products = {
    'bar-mitzvah-kippah-1': ['kp-ready-bar-mitzvah-star-of-david'],
    'bar-mitzvah-kippah-2': ['kp-ready-bar-mitzvah-lions-and-crown'],
    'bar-mitzvah-ariel': ['kp-ready-bar-mitzvah-star-of-david-and-laurel'],
    'bar-mitzvah-noam': ['kp-sparkles-noam', {
      Silver: `${fileRoot}kp-sparkles-noam-silver.png?v=1790936871`,
      Gold: `${fileRoot}kp-sparkles-noam-gold.png?v=1790936886`
    }],
    'bar-mitzvah-benjamin': ['kp-ready-bar-mitzvah-tefillin'],
    'bar-mitzvah-gabriel': ['kp-ready-bar-mitzvah-hamsa-hand'],
    'bar-mitzvah-levi': ['kp-ready-bar-mitzvah-hamsa-hand-classic'],
    'bar-mitzvah-nathan': ['kp-ready-bar-mitzvah-soccer-ball-number-13'],
    'bar-mitzvah-samuel': ['kp-ready-bar-mitzvah-basketball-player'],
    'bar-mitzvah-michael': ['kp-ready-bar-mitzvah-hockey-player'],
    'hegia-lmitzvot_bar-mitzvah': ['kp-ready-bar-mitzvah-hegia-lmitzvot-outside'],
    'wedding-yael-roni': ['kp-ready-wedding-interlocking-rings'],
    'wedding-maya-erez': ['kp-ready-wedding-eucalyptus-greenery'],
    'wedding-eden-david': ['kp-ready-wedding-interlocking-rings-classic'],
    'wedding-yonit-michael': ['kp-ready-wedding-white-rose'],
    'wedding-sivan-benjamin': ['kp-ready-wedding-rings'],
    'wedding-adam-hawa': ['kp-ready-wedding-floral-bouquet'],
    'wedding-abraham-sarah': ['kp-ready-wedding-hamsa-hand'],
    'wedding-boaz-ruth': ['kp-ready-wedding-floral-bouquet-classic'],
    'wedding-aviv-noam': ['kp-ready-wedding-simple-rings'],
    'wedding-rivkah-shalom': ['kp-ready-wedding-heart-and-rings'],
    'rings-and-flowers-wedding': ['kp-ready-wedding-rings-flowers-outside'],
    'brit-milah-moshe': ['kp-ready-brit-milah-baby-pin-charms'],
    'brit-milah-daniel': ['kp-ready-brit-milah-minimalist-baby-line-art'],
    'brit-milah-chaim': ['kp-ready-brit-milah-heart-footprints'],
    'brit-milah-benjamin': ['kp-ready-brit-milah-teddy-bear-classic', { Multicolor: `${fileRoot}kp-ready-brit-milah-teddy-bear-classic.png` }],
    'brit-milah-azriel': ['kp-ready-brit-milah-star-of-david-balloons', { Multicolor: `${fileRoot}kp-ready-brit-milah-star-of-david-balloons.png` }],
    'brit-milah-alon': ['kp-ready-brit-milah-teddy-bear-balloons', { Multicolor: `${fileRoot}kp-ready-brit-milah-teddy-bear-balloons.png` }],
    'brit-milah-noah': ['kp-ready-brit-milah-stars-hearts'],
    'brit-milah-david': ['kp-ready-brit-milah-bear-balloons', { Multicolor: `${fileRoot}kp-ready-brit-milah-bear-balloons.png` }],
    'brit-milah-levi': ['kp-ready-brit-milah-hamsa-hand', { Multicolor: `${fileRoot}kp-ready-brit-milah-hamsa-hand.png` }],
    'brit-milah-eliezer': ['kp-ready-brit-milah-teddy-bear-blue-ribbon-balloons', { Multicolor: `${fileRoot}kp-ready-brit-milah-teddy-bear-blue-ribbon-balloons.png` }],
    'hanukkah-menora-holiday-kippah-1': ['', {
      Silver: `${fileRoot}kp-ready-holiday-hanukkah-menora-silver.png?v=1791045481`,
      Gold: `${fileRoot}kp-ready-holiday-hanukkah-menora-gold.png?v=1791045503`
    }],
    'hanukkah-menora-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-hanukkah-menorah-classic-silver.png?v=1791045524`,
      Gold: `${fileRoot}kp-ready-holiday-hanukkah-menorah-classic-gold.png?v=1791045515`
    }],
    'hanukkah-menorah-coloured-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-hanukkah-menorah-coloured.png?v=1791045534`
    }, {
      Multicolor: `${fileRoot}kp-ready-holiday-hanukkah-menorah-coloured-light.png?v=1791043535`
    }],
    'hanukkah-menorah-simple-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-hanukkah-menorah-simple-silver.png?v=1791045560`,
      Gold: `${fileRoot}kp-ready-holiday-hanukkah-menorah-simple-gold.png?v=1791045551`,
      Blue: `${fileRoot}kp-ready-holiday-hanukkah-menorah-simple-blue.png?v=1791045543`
    }],
    'hanukkah-sevivon-coloured-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-hanukkah-sevivon-coloured.png?v=1791045569`
    }, {
      Multicolor: `${fileRoot}kp-ready-holiday-hanukkah-sevivon-coloured-light.png?v=1791043544`
    }],
    'hanukkah-sevivon-gold-silver-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-hanukkah-sevivon-gold-silver.png?v=1791045577`
    }],
    'hanukkah-sufganiyah-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-hanukkah-sufganiyah-silver.png?v=1791045594`,
      Gold: `${fileRoot}kp-ready-holiday-hanukkah-sufganiyah-gold.png?v=1791045586`
    }],
    'shavuot-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-shavuot-silver.png?v=1791045652`,
      Gold: `${fileRoot}kp-ready-holiday-shavuot-gold.png?v=1791045625`
    }],
    'shavuot-classic-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-shavuot-classic-silver.png?v=1791045616`,
      Gold: `${fileRoot}kp-ready-holiday-shavuot-classic-gold.png?v=1791045606`
    }],
    'shavuot-coloured-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-shavuot-coloured.png?v=1791045633`
    }, {
      Multicolor: `${fileRoot}kp-ready-holiday-shavuot-coloured-light.png?v=1791043553`
    }],
    'shavuot-simple-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-shavuot-simple-silver.png?v=1791045677`,
      Gold: `${fileRoot}kp-ready-holiday-shavuot-simple-gold.png?v=1791045643`,
      Purple: `${fileRoot}kp-ready-holiday-shavuot-simple-purple.png?v=1791045660`
    }],
    'shavuot-torah-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-shavuot-torah.png?v=1791045668`
    }, {
      Multicolor: `${fileRoot}kp-ready-holiday-shavuot-torah-light.png?v=1791043563`
    }],
    'sukkot-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-sukkot-silver.png?v=1791045733`,
      Gold: `${fileRoot}kp-ready-holiday-sukkot-gold.png?v=1791045713`
    }],
    'sukkot-chag-sameach-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-sukkot-chag-sameach.png?v=1791045686`
    }, {
      Multicolor: `${fileRoot}kp-ready-holiday-sukkot-chag-sameach-light.png?v=1791043571`
    }],
    'sukkot-classic-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-sukkot-classic-silver.png?v=1791045723`,
      Gold: `${fileRoot}kp-ready-holiday-sukkot-classic-gold.png?v=1791045695`
    }],
    'sukkot-coloured-holiday-kippah': ['', {
      Multicolor: `${fileRoot}kp-ready-holiday-sukkot-coloured.png?v=1791045705`
    }, {
      Multicolor: `${fileRoot}kp-ready-holiday-sukkot-coloured-light.png?v=1791043579`
    }],
    'sukkot-simple-holiday-kippah': ['', {
      Silver: `${fileRoot}kp-ready-holiday-sukkot-simple-silver.png?v=1791045779`,
      Gold: `${fileRoot}kp-ready-holiday-sukkot-simple-gold.png?v=1791045758`,
      Green: `${fileRoot}kp-ready-holiday-sukkot-simple-green.png?v=1791045770`
    }]
  };

  const fixedPairs = {
    'hegia-lmitzvot_bar-mitzvah': {
      outside: { Silver: `${fileRoot}kp-ready-bar-mitzvah-hegia-lmitzvot-outside-silver.png`, Gold: `${fileRoot}kp-ready-bar-mitzvah-hegia-lmitzvot-outside-gold.png` },
      inside: { Silver: `${fileRoot}kp-ready-bar-mitzvah-hegia-lmitzvot-inside-silver.png`, Gold: `${fileRoot}kp-ready-bar-mitzvah-hegia-lmitzvot-inside-gold.png` }
    },
    'rings-and-flowers-wedding': {
      outside: { Silver: `${fileRoot}kp-ready-wedding-rings-flowers-outside-silver.png`, Gold: `${fileRoot}kp-ready-wedding-rings-flowers-outside-gold.png` },
      inside: { Silver: `${fileRoot}kp-ready-wedding-rings-flowers-inside-silver.png`, Gold: `${fileRoot}kp-ready-wedding-rings-flowers-inside-gold.png` }
    }
  };

  if (window.__kpReadyArtworkPreview?.handle === handle) return;
  window.__kpReadyArtworkPreview?.destroy?.();

  const product = products[handle];
  if (!product) return;
  const artwork = product[1] || {
    Silver: `${fileRoot}${product[0]}-silver.png`,
    Gold: `${fileRoot}${product[0]}-gold.png`
  };
  const lightArtwork = product[2] || null;
  const linenCatalog = window.__kpReadyLinenCatalog = Object.freeze({
    'Linen Baby Blue': { handle: 'baby-blue-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Baby_Blue_Linen_Kippah_800x800_6a6eba5e-598b-4440-aae6-6a044f0647e4.png?v=1793320866', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Baby_Blue_Linen_Kippah_X2_800x800_e3342140-38f0-4192-b0d0-d8a997280545.png?v=1793320866', geometry: { single: { x: 1301.78, y: 2094.35, angle: 9.744, side: 840 }, outside: { x: 829.53, y: 2239.05, angle: 6.818, side: 582 }, inside: { x: 1944, y: 1836.55, angle: 25.084, side: 582 } } },
    'Linen Baby Pink': { handle: 'baby-pink-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Baby_Pink_Linen_Kippah_800x800_2e477599-c0ad-4295-b4ff-5de558e17e1a.png?v=1793320867', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Baby_Pink_Linen_Kippah_X2_800x800_d77ae65c-7420-43b7-9655-f9cb0be7a0ad.png?v=1793320866', geometry: { single: { x: 1361.5, y: 2084.52, angle: 5.641, side: 840 }, outside: { x: 866.66, y: 2227, angle: 7.539, side: 582 }, inside: { x: 1979.73, y: 1854.23, angle: 28.237, side: 582 } } },
    'Linen Black': { handle: 'black-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Black_Linen_Kippah_800x800_a54cf033-8ecc-4516-bb9c-7de710c08e1f.png?v=1793320868', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Black_Linen_Kippah_X2_800x800_74aadb3a-2608-406d-8dcd-a1a093781f52.png?v=1793320868', geometry: { single: { x: 1248.82, y: 2090.6, angle: 8.344, side: 840 }, outside: { x: 797.47, y: 2208.29, angle: 11.094, side: 582 }, inside: { x: 1945.63, y: 1845.41, angle: 28.217, side: 582 } } },
    'Linen Cream': { handle: 'cream-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Cream_Linen_Kippah_800x800_c5caca72-6b8f-4949-ae80-fb0932160e5f.png?v=1793320869', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Cream_Linen_Kippah_X2_800x800_749aeac7-c9ce-4087-be07-3d47045c26b3.png?v=1793320868', geometry: { single: { x: 1310.44, y: 2086.99, angle: 8.354, side: 840 }, outside: { x: 828.89, y: 2230.73, angle: 8.531, side: 582 }, inside: { x: 1969.75, y: 1841.12, angle: 25.463, side: 582 } } },
    'Linen Dark Grey': { handle: 'dark-grey-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Dark_Grey_Linen_Kippah_800x800_a46f8b6f-4cfb-4c9e-bda2-ad3064460660.png?v=1793320869', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Dark_Grey_Linen_Kippah_X2_800x800_b305e847-b3bf-4263-a3a1-9e49113940e7.png?v=1793320870', geometry: { single: { x: 1256.25, y: 2062, angle: 11.677, side: 840 }, outside: { x: 802.22, y: 2223.09, angle: 11.802, side: 582 }, inside: { x: 1975.26, y: 1842.86, angle: 24.567, side: 582 } } },
    'Linen Ivory': { handle: 'ivory-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Ivory_Linen_Kippah_800x800_a14845c9-6cf6-418b-9ede-7d13dd85ea36.png?v=1793320871', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Ivory_Linen_Kippah_X2_800x800_615196f9-c871-42d0-97f8-975859aae641.png?v=1793320870', geometry: { single: { x: 1325.49, y: 2103.65, angle: 7.874, side: 840 }, outside: { x: 863.15, y: 2213.21, angle: 8.427, side: 582 }, inside: { x: 1980.98, y: 1838.15, angle: 26.966, side: 582 } } },
    'Linen Light Blue': { handle: 'light-blue-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Light_Blue_Linen_Kippah_800x800_cdbf1b71-ac85-41e1-8bdb-f48803d6cc22.png?v=1793320871', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Light_Blue_Linen_Kippah_X2_800x800_24bf8aaf-cbea-4dfc-b5c0-21a239122f9d.png?v=1793320872', geometry: { single: { x: 1294.92, y: 2085.32, angle: 10.214, side: 840 }, outside: { x: 840.82, y: 2210.36, angle: 11.575, side: 582 }, inside: { x: 1970.48, y: 1837.59, angle: 28.237, side: 582 } } },
    'Linen Light Grey': { handle: 'light-grey-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Light_Grey_Linen_Kippah_800x800_260668d6-dfb4-4c43-af17-d5a5e4f0f643.png?v=1793320872', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Light_Grey_Linen_Kippah_X2_800x800_be85a939-f0e5-44db-8676-d54676dd68ce.png?v=1793320873', geometry: { single: { x: 1236.45, y: 2105.08, angle: 10.976, side: 840 }, outside: { x: 788.46, y: 2208.4, angle: 11.083, side: 582 }, inside: { x: 1909.2, y: 1854.53, angle: 28.237, side: 582 } } },
    'Linen Navy Blue': { handle: 'navy-blue-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Navy_Blue_Linen_Kippah_800x800_a020d921-8ffe-4385-af60-dbec974047ad.png?v=1793320873', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Navy_Blue_Linen_Kippah_X2_800x800_398a9684-4c3b-4f3f-8ed3-7fb0314a6914.png?v=1793320873', geometry: { single: { x: 1302.24, y: 2082.35, angle: 6.394, side: 840 }, outside: { x: 830.17, y: 2229.57, angle: 6.404, side: 582 }, inside: { x: 1961.66, y: 1807.26, angle: 29.982, side: 582 } } },
    'Linen Royal Blue': { handle: 'royal-blue-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Royal_Blue_Linen_Kippah_800x800_89ca1405-8c48-4cb0-8b54-16b294310d6b.png?v=1793320874', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/Royal_Blue_Linen_Kippah_X2_800x800_e602f7fa-69d0-4e89-a0dd-78a8b1f4f32f.png?v=1793320874', geometry: { single: { x: 1342.43, y: 2080.73, angle: 7.745, side: 840 }, outside: { x: 858.45, y: 2204.38, angle: 6.404, side: 582 }, inside: { x: 1920.92, y: 1824.62, angle: 33.69, side: 582 } } },
    'Linen White': { handle: 'white-linen-kippah', single: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/White_Linen_Kippah_800x800_5224a44a-d3e1-452f-88db-f17ecf792693.png?v=1793320875', paired: 'https://cdn.shopify.com/s/files/1/0718/3135/5545/files/White_Linen_Kippah_X2_800x800_ab8958a6-31b5-42de-bb1a-eec1f7f42df5.png?v=1793320876', geometry: { single: { x: 1303.88, y: 2108.44, angle: 8.344, side: 840 }, outside: { x: 819.43, y: 2252.37, angle: 6.557, side: 582 }, inside: { x: 1886.18, y: 1850.3, angle: 25.741, side: 582 } } }
  });
  const linenVariantIds = window.__kpReadyLinenVariantIds = Object.freeze({
    'Linen Baby Blue': { 'Outside Print': '67862228467865', 'Inside Print': '67899731542169', 'Double-Sided Print': '67899731574937' },
    'Linen Baby Pink': { 'Outside Print': '67862228697241', 'Inside Print': '67899733246105', 'Double-Sided Print': '67899733278873' },
    'Linen Black': { 'Outside Print': '67862229057689', 'Inside Print': '67899733311641', 'Double-Sided Print': '67899733344409' },
    'Linen Cream': { 'Outside Print': '67862229680281', 'Inside Print': '67899733442713', 'Double-Sided Print': '67899733475481' },
    'Linen Dark Grey': { 'Outside Print': '67862230171801', 'Inside Print': '67899733541017', 'Double-Sided Print': '67899733573785' },
    'Linen Ivory': { 'Outside Print': '67862230204569', 'Inside Print': '67899733639321', 'Double-Sided Print': '67899733672089' },
    'Linen Light Blue': { 'Outside Print': '67862230597785', 'Inside Print': '67899733737625', 'Double-Sided Print': '67899733770393' },
    'Linen Light Grey': { 'Outside Print': '67862230925465', 'Inside Print': '67899733835929', 'Double-Sided Print': '67899733868697' },
    'Linen Navy Blue': { 'Outside Print': '67862230991001', 'Inside Print': '67899733901465', 'Double-Sided Print': '67899733934233' },
    'Linen Royal Blue': { 'Outside Print': '67862231023769', 'Inside Print': '67899733999769', 'Double-Sided Print': '67899734032537' },
    'Linen White': { 'Outside Print': '67862232039577', 'Inside Print': '67899734065305', 'Double-Sided Print': '67899734098073' }
  });
  const artworkFor = (kippah, printColor) => {
    const useLight = /^(?:Lined Navy|Lined Black|Linen Navy Blue|Linen Black)$/.test(kippah) && lightArtwork;
    const palette = useLight ? lightArtwork : artwork;
    const onlyArtwork = Object.keys(palette).length === 1 ? Object.values(palette)[0] : '';
    return palette[printColor] || onlyArtwork || artwork[printColor] || '';
  };

  const backgrounds = {
    'Classic White': { single: 'https://kippush.ca/cdn/shop/files/White_Satin_Classic.png?width=3840' },
    'Lined White': {
      single: 'https://kippush.ca/cdn/shop/files/White_Satin_Lining_Single.png?v=1790521822&width=3840',
      paired: 'https://kippush.ca/cdn/shop/files/White_Satin_Lining_68b6adf1-c2b0-45c2-bf16-e6228b4ef222.png?v=1790900485&width=3840'
    },
    'Lined Navy': {
      single: 'https://kippush.ca/cdn/shop/files/blank-lined-navy-satin-kippah.png?v=1790883546&width=3840',
      paired: 'https://kippush.ca/cdn/shop/files/Blue_Satin_Lining_7682ecf7-59a9-4433-b20b-7b9901f37015.png?v=1790900309&width=3840'
    },
    'Lined Black': {
      single: 'https://kippush.ca/cdn/shop/files/blank-lined-black-satin-kippah.png?v=1790883547&width=3840',
      paired: 'https://kippush.ca/cdn/shop/files/Black_Satin_Lining_fb1e6a81-7aae-41f3-a53e-75abc942e9d5.png?v=1790900258&width=3840'
    }
  };
  Object.entries(linenCatalog).forEach(([name, item]) => { backgrounds[name] = { single: item.single, paired: item.paired }; });

  const placements = {
    'Classic White': { single: { x: 1265, y: 2097, angle: 3.5, side: 806 } },
    'Lined White': {
      single: { x: 1350.04, y: 2097.53, angle: 1.8083, side: 840 },
      outside: { x: 887.26, y: 2256.85, angle: 3.8983, side: 582 },
      inside: { x: 2171.52, y: 1738.37, angle: 24.2037, side: 582 }
    },
    'Lined Navy': {
      single: { x: 1304.24, y: 2099.15, angle: 6.0043, side: 840 },
      outside: { x: 726.73, y: 2160.73, angle: 22.1891, side: 582 },
      inside: { x: 2075.38, y: 1749.62, angle: 32.7999, side: 582 }
    },
    'Lined Black': {
      single: { x: 1369.09, y: 2114.39, angle: 2.4074, side: 840 },
      outside: { x: 813.63, y: 2211.85, angle: 7.5003, side: 582 },
      inside: { x: 2029.39, y: 1794.61, angle: 24.3004, side: 582 }
    }
  };
  Object.entries(linenCatalog).forEach(([name, item]) => { placements[name] = item.geometry; });

  const namespace = 'http://www.w3.org/2000/svg';
  const sourceWidth = 3024;
  const sourceHeight = 4032;
  const controller = new AbortController();
  const { signal } = controller;
  let observer;
  let timer;
  let readyChoice = '';
  let applyingReadyChoice = false;

  const checkedValue = (nameStart) => [...document.querySelectorAll(`main input[type="radio"][name^="${nameStart}"]:checked`)]
    .find((input) => input.closest('main'))?.value || '';
  const readySide = () => document.querySelector('main input[name="properties[Ready design placement]"]:checked')?.value || '';

  const ensureReadySide = (printPlacement) => {
    if (printPlacement !== 'Double-Sided Print') return;
    if (readySide()) {
      readyChoice = readySide();
      return;
    }
    const value = readyChoice || 'Outside';
    const input = [...document.querySelectorAll('main input[name="properties[Ready design placement]"]')]
      .find((candidate) => candidate.value === value);
    if (!input) return;
    applyingReadyChoice = true;
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    applyingReadyChoice = false;
    readyChoice = value;
  };

  const placementKey = (printPlacement) => {
    if (printPlacement === 'Outside Print') return 'single';
    if (printPlacement === 'Inside Print') return 'inside';
    if (printPlacement === 'Double-Sided Print') return readySide() === 'Inside' ? 'inside' : 'outside';
    return '';
  };

  const objectPositionRatio = (value, axis) => {
    const keywords = axis === 'x' ? { left: 0, center: 0.5, right: 1 } : { top: 0, center: 0.5, bottom: 1 };
    if (Object.hasOwn(keywords, value)) return keywords[value];
    if (value.endsWith('%')) return Number.parseFloat(value) / 100;
    return 0.5;
  };

  const objectPosition = (value) => {
    let x = '';
    let y = '';
    value.trim().split(/\s+/).forEach((token) => {
      if (/^(?:left|right)$/.test(token)) x = token;
      else if (/^(?:top|bottom)$/.test(token)) y = token;
      else if (!x) x = token;
      else if (!y) y = token;
    });
    return [objectPositionRatio(x || '50%', 'x'), objectPositionRatio(y || '50%', 'y')];
  };

  const mapGeometry = (container, sourceImage, geometry) => {
    const containerRect = container.getBoundingClientRect();
    const imageRect = sourceImage.getBoundingClientRect();
    const style = window.getComputedStyle(sourceImage);
    const containScale = Math.min(imageRect.width / sourceWidth, imageRect.height / sourceHeight);
    const coverScale = Math.max(imageRect.width / sourceWidth, imageRect.height / sourceHeight);
    let scaleX = containScale;
    let scaleY = containScale;
    if (style.objectFit === 'cover') scaleX = scaleY = coverScale;
    else if (style.objectFit === 'fill') {
      scaleX = imageRect.width / sourceWidth;
      scaleY = imageRect.height / sourceHeight;
    } else if (style.objectFit === 'none') scaleX = scaleY = 1;
    else if (style.objectFit === 'scale-down') scaleX = scaleY = Math.min(1, containScale);
    const [positionX, positionY] = objectPosition(style.objectPosition);
    const renderedWidth = sourceWidth * scaleX;
    const renderedHeight = sourceHeight * scaleY;
    const left = imageRect.left - containerRect.left + (imageRect.width - renderedWidth) * positionX;
    const top = imageRect.top - containerRect.top + (imageRect.height - renderedHeight) * positionY;
    return {
      x: left + geometry.x * scaleX,
      y: top + geometry.y * scaleY,
      width: geometry.side * scaleX,
      height: geometry.side * scaleY,
      angle: geometry.angle,
      viewBox: `0 0 ${containerRect.width} ${containerRect.height}`
    };
  };

  const makeOverlay = () => {
    const svg = document.createElementNS(namespace, 'svg');
    svg.classList.add('kp-ready-artwork-preview');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    Object.assign(svg.style, {
      position: 'absolute', inset: '0', width: '100%', height: '100%', overflow: 'hidden', pointerEvents: 'none', zIndex: '2'
    });
    return svg;
  };

  const activeImages = () => [...document.querySelectorAll(
    'main .product-information[data-testid="product-information"] .product-information__media img.product-media__image'
  )].filter((image) => {
    const rect = image.getBoundingClientRect();
    const style = window.getComputedStyle(image);
    return rect.width > 240 && rect.height > 240 && style.display !== 'none' && style.visibility !== 'hidden'
      && image.closest('main .product-information[data-testid="product-information"] .product-information__media');
  });

  const draw = (container, sourceImage, layers) => {
    let svg = container.querySelector(':scope > .kp-ready-artwork-preview');
    if (!svg) {
      svg = makeOverlay();
      if (window.getComputedStyle(container).position === 'static') container.style.position = 'relative';
      container.append(svg);
    }
    if (svg.children.length !== layers.length) {
      svg.replaceChildren(...layers.map(() => {
        const image = document.createElementNS(namespace, 'image');
        image.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        return image;
      }));
    }
    layers.forEach((layer, index) => {
      const mapped = mapGeometry(container, sourceImage, layer.geometry);
      if (index === 0) svg.setAttribute('viewBox', mapped.viewBox);
      const image = svg.children[index];
      image.setAttribute('href', layer.url);
      image.setAttribute('x', String(mapped.x - mapped.width / 2));
      image.setAttribute('y', String(mapped.y - mapped.height / 2));
      image.setAttribute('width', String(mapped.width));
      image.setAttribute('height', String(mapped.height));
      image.setAttribute('transform', `rotate(${mapped.angle} ${mapped.x} ${mapped.y})`);
    });
  };

  const render = () => {
    observer?.disconnect();
    try {
      document.querySelectorAll('.kp-sparkles-preview').forEach((node) => node.remove());
      const printColor = checkedValue('Print Color-');
      const kippah = window.__kpReadyLinenSelection || checkedValue('Kippah-');
      const printPlacement = checkedValue('Print Placement-');
      const fixedPair = fixedPairs[handle];
      if (!fixedPair) ensureReadySide(printPlacement);
      const key = placementKey(printPlacement);
      const geometry = placements[kippah]?.[key];
      const artworkUrl = artworkFor(kippah, printColor);
      const fixedOutsideGeometry = placements[kippah]?.outside;
      const weddingOutsideGeometry = handle === 'rings-and-flowers-wedding' && fixedOutsideGeometry
        ? { ...fixedOutsideGeometry, side: Math.round(fixedOutsideGeometry.side * 0.85) }
        : fixedOutsideGeometry;
      const layers = fixedPair
        ? [
          { url: fixedPair.outside[printColor], geometry: weddingOutsideGeometry },
          { url: fixedPair.inside[printColor], geometry: placements[kippah]?.inside }
        ]
        : [{ url: artworkUrl, geometry }];
      const images = layers.every((layer) => layer.geometry && layer.url) ? activeImages() : [];
      const background = backgrounds[kippah]?.[fixedPair ? 'paired' : key === 'single' ? 'single' : 'paired'];
      images.forEach((image) => {
        if (!background) return;
        const paired = Boolean(fixedPair) || key !== 'single';
        image.closest('.product-media-container')?.toggleAttribute('data-kp-paired-preview', paired);
        image.style.setProperty('object-fit', 'cover', 'important');
        const previewUrl = (width) => /[?&]width=\d+/.test(background)
          ? background.replace(/([?&])width=\d+/, `$1width=${width}`)
          : `${background}${background.includes('?') ? '&' : '?'}width=${width}`;
        const previewSrcset = [480, 768, 1200, 1600, 2400, 3840].map((width) => `${previewUrl(width)} ${width}w`).join(', ');
        if (image.srcset !== previewSrcset) image.srcset = previewSrcset;
        image.sizes = '(min-width: 750px) 50vw, 100vw';
        if (image.src !== previewUrl(1600)) image.src = previewUrl(1600);
      });
      const containers = new Map(images.map((image) => [image.closest('.product-media-container') || image.parentElement, image]).filter(([container]) => Boolean(container)));
      document.querySelectorAll('.kp-ready-artwork-preview').forEach((svg) => {
        if (!containers.has(svg.parentElement)) svg.remove();
      });
      containers.forEach((image, container) => draw(container, image, layers));
    } finally {
      observer?.observe(document.body, { childList: true, subtree: true });
    }
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(render, 80);
  };
  document.addEventListener('kp:preview-refresh', render, { signal });
  document.addEventListener('change', (event) => {
    if (!applyingReadyChoice && event.target?.name === 'properties[Ready design placement]' && event.target.checked) readyChoice = event.target.value;
    schedule();
  }, { capture: true, signal });
  document.addEventListener('input', schedule, { capture: true, signal });
  document.addEventListener('variant:update', schedule, { capture: true, signal });
  window.addEventListener('popstate', schedule, { signal });
  window.addEventListener('pageshow', schedule, { signal });
  window.addEventListener('resize', schedule, { passive: true, signal });

  const destroy = () => {
    controller.abort();
    observer?.disconnect();
    window.clearTimeout(timer);
    document.querySelectorAll('.kp-ready-artwork-preview').forEach((svg) => svg.remove());
    if (window.__kpReadyArtworkPreview?.handle === handle) delete window.__kpReadyArtworkPreview;
  };
  observer = new MutationObserver((records) => { if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches('media-gallery,kp-print-content,variant-picker') || node.querySelector('media-gallery,kp-print-content,variant-picker'))))) schedule(); });
  observer.observe(document.body, { childList: true, subtree: true });
  window.__kpReadyArtworkPreview = { handle, destroy };
  schedule();
})();

(() => {
  window.__kpHolidayColorAvailability?.destroy?.();

  const restrictedByHandle = Object.freeze({
    'hanukkah-menorah-simple-holiday-kippah': 'Blue',
    'shavuot-simple-holiday-kippah': 'Purple',
    'sukkot-simple-holiday-kippah': 'Green'
  });
  const darkKippahs = new Set(['Lined Navy', 'Lined Black']);
  const controller = new AbortController();
  const { signal } = controller;
  let observer;
  let timer;

  const productHandle = () => window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
  const fieldsets = () => [...document.querySelectorAll('main variant-picker fieldset.variant-option')];
  const fieldsetNamed = (pattern) => fieldsets().find((fieldset) => {
    const legend = fieldset.querySelector('legend')?.textContent || '';
    const name = fieldset.querySelector('input[type="radio"]')?.name || '';
    return pattern.test(`${legend} ${name}`);
  });
  const checkedValue = (fieldset) => fieldset?.querySelector('input[type="radio"]:checked')?.value || '';

  const restore = () => {
    document.querySelectorAll('[data-kp-holiday-color-restricted]').forEach((label) => {
      label.hidden = false;
      delete label.dataset.kpHolidayColorRestricted;
      const input = label.querySelector('input[type="radio"]');
      if (input) input.disabled = false;
    });
  };

  const apply = () => {
    observer?.disconnect();
    try {
      restore();
      const restrictedColor = restrictedByHandle[productHandle()];
      if (!restrictedColor) return;
      const colorFieldset = fieldsetNamed(/print color/i);
      const kippahFieldset = fieldsetNamed(/kippah/i);
      if (!colorFieldset || !kippahFieldset) return;
      const restrictedInput = [...colorFieldset.querySelectorAll('input[type="radio"]')]
        .find((input) => input.value === restrictedColor);
      const restrictedLabel = restrictedInput?.closest('.variant-option__button-label') || restrictedInput?.closest('label');
      if (!restrictedInput || !restrictedLabel) return;
      const isDark = darkKippahs.has(checkedValue(kippahFieldset))
        || /^(?:Linen Navy Blue|Linen Black)$/.test(window.__kpReadyLinenSelection || '');
      if (isDark && restrictedInput.checked) {
        const silver = [...colorFieldset.querySelectorAll('input[type="radio"]')]
          .find((input) => input.value === 'Silver' && !input.disabled);
        silver?.click();
      }
      restrictedInput.disabled = isDark;
      restrictedLabel.hidden = isDark;
      if (isDark) restrictedLabel.dataset.kpHolidayColorRestricted = restrictedColor;
    } finally {
      observer?.observe(document.body, { childList: true, subtree: true });
    }
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, 60);
  };

  document.addEventListener('change', schedule, { capture: true, signal });
  document.addEventListener('variant:update', schedule, { capture: true, signal });
  document.addEventListener('kp:ready-linen-selection', schedule, { signal });
  document.addEventListener('shopify:section:load', schedule, { signal });
  window.addEventListener('popstate', schedule, { signal });
  window.addEventListener('pageshow', schedule, { signal });

  const destroy = () => {
    controller.abort();
    observer?.disconnect();
    window.clearTimeout(timer);
    restore();
    if (window.__kpHolidayColorAvailability?.destroy === destroy) delete window.__kpHolidayColorAvailability;
  };

  observer = new MutationObserver((records) => { if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches('media-gallery,kp-print-content,variant-picker') || node.querySelector('media-gallery,kp-print-content,variant-picker'))))) schedule(); });
  observer.observe(document.body, { childList: true, subtree: true });
  window.__kpHolidayColorAvailability = { destroy, render: apply };
  schedule();
})();

(() => {
  window.__kpKippahVariantClarity?.destroy?.();

  const controller = new AbortController();
  const { signal } = controller;
  const productCache = new Map();
  let observer;
  let timer;

  const style = document.createElement('style');
  style.dataset.kpKippahVariantClarity = '';
  style.textContent = `
    .kp-kippah-variant-clarity [data-testid="product-information-details"] > .group-block > .group-block-content {
      gap: 10px !important;
    }
    .kp-kippah-variant-clarity [class*="__group_icgrde"] > .group-block-content {
      gap: 6px !important;
    }
    .kp-kippah-variant-clarity product-price .price {
      font-size: 1.125rem;
      font-weight: 700;
      line-height: 1.2;
    }
    .kp-kippah-variant-clarity variant-picker .variant-picker__form {
      gap: 10px;
    }
    .kp-kippah-variant-clarity variant-picker fieldset.variant-option {
      margin-block: 0;
      row-gap: 8px;
    }
    .kp-kippah-variant-clarity variant-picker fieldset.kp-kippah-options {
      display: block !important;
      width: 100%;
      --variant-ch: 0em !important;
    }
    .kp-kippah-variant-clarity fieldset.kp-kippah-options > legend {
      margin-bottom: 8px;
    }
    .kp-kippah-variant-clarity fieldset.kp-kippah-options > .variant-option__button-label {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }
    .kp-kippah-variant-clarity .kp-kippah-select {
      appearance: none;
      display: block;
      width: 100%;
      height: 54px !important;
      min-height: 54px !important;
      padding: 12px 48px 12px 16px;
      border: 2px solid #273be2;
      border-radius: 12px;
      background-color: #eaf0ff;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='m5 7.5 5 5 5-5' stroke='%2323345c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-position: right 15px center;
      background-repeat: no-repeat;
      color: #23345c;
      font: inherit;
      font-weight: 700;
      line-height: 1.25;
      cursor: pointer;
      box-shadow: 0 2px 0 rgb(39 59 226 / 0.08);
    }
    .kp-kippah-variant-clarity .kp-kippah-select:focus-visible {
      outline: 3px solid #7183f1;
      outline-offset: 3px;
    }
    .kp-kippah-variant-clarity .kp-linen-preview-note {
      margin: 8px 0 0;
      padding: 10px 12px;
      border-radius: 10px;
      background: #fff4d6;
      color: #5f4300;
      font-size: 0.82rem;
      font-weight: 600;
      line-height: 1.4;
    }
    .kp-kippah-variant-clarity .kp-choice-prices .variant-option__button-label__text {
      display: block;
      line-height: 1.15;
      white-space: normal;
    }
    .kp-kippah-variant-clarity .kp-choice-prices > .variant-option__button-label {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      text-align: center;
    }
    .kp-kippah-variant-clarity .kp-variant-choice-price {
      display: block;
      margin-top: 3px;
      font-size: 0.7rem;
      font-weight: 500;
      line-height: 1.1;
      opacity: 0.68;
      white-space: nowrap;
    }
    .kp-kippah-variant-clarity .variant-option__button-label:has(input:checked) .kp-variant-choice-price {
      opacity: 0.86;
    }
    @media screen and (max-width: 749px) {
      .kp-kippah-variant-clarity .kp-kippah-select {
        min-height: 52px;
        font-size: 16px;
      }
      .kp-kippah-variant-clarity .kp-variant-choice-price {
        font-size: 0.72rem;
      }
    }
  `;
  document.head.append(style);

  const productRoot = () => document.querySelector('main .product-information[data-testid="product-information"]');
  const productHandle = () => window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
  const checkedOptionValue = (nameStart) => [...document.querySelectorAll(`main input[type="radio"][name^="${nameStart}"]:checked`)]
    .find((input) => input.closest('main'))?.value || '';
  const isKippahProduct = () => /kippah/i.test(productHandle())
    || Boolean(document.querySelector('main variant-picker[data-kp-placement-active]'));

  const restoreLinenSelection = () => {
    const root = document.documentElement;
    if (root.dataset.kpReadyLinenProduct === productHandle() && root.dataset.kpReadyLinenSelection) {
      window.__kpReadyLinenSelection = root.dataset.kpReadyLinenSelection;
      return;
    }
    delete root.dataset.kpReadyLinenProduct;
    delete root.dataset.kpReadyLinenSelection;
    window.__kpReadyLinenSelection = '';
  };
  restoreLinenSelection();

  const setLinenProperty = (form, key, value) => {
    let input = form.querySelector(`input[data-kp-ready-linen-property="${key}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.dataset.kpReadyLinenProperty = key;
      input.name = `properties[${key}]`;
      form.append(input);
    }
    input.value = value;
  };

  const clearLinenOrderState = () => {
    document.querySelectorAll('main .product-information form[action*="/cart/add"]').forEach((form) => {
      delete form.dataset.kpVariantOverride;
      form.querySelectorAll('[data-kp-ready-linen-property]').forEach((input) => input.remove());
      const component = form.closest('product-form-component');
      if (component) {
        delete component.dataset.kpVariantOverride;
        delete component.dataset.kpReadyLinenActive;
      }
    });
  };

  const linenTierConfig = (placement = checkedOptionValue('Print Placement-')) => ({
    mins: [10, 20, 30, 50, 60, 100],
    prices: placement === 'Double-Sided Print'
      ? [2100, 1500, 1300, 1150, 1100, 1050]
      : [2000, 1400, 1200, 1050, 1000, 950]
  });

  const linenTierPrice = (quantity, placement) => {
    const config = linenTierConfig(placement);
    let index = 0;
    config.mins.forEach((min, candidate) => { if (quantity >= min) index = candidate; });
    return config.prices[index];
  };

  const syncLinenLadder = (active, placement) => {
    document.querySelectorAll('main .kp-ladder--ready').forEach((box) => {
      const list = box.querySelector('ul');
      if (!list) return;
      if (!box.dataset.kpLinenOriginalHtml) {
        box.dataset.kpLinenOriginalHtml = list.innerHTML;
        box.dataset.kpLinenOriginalBase = box.dataset.base || '';
        box.dataset.kpLinenOriginalMins = box.dataset.mins || '';
        box.dataset.kpLinenOriginalDiscounts = box.dataset.discounts || '';
      }

      if (!active) {
        list.innerHTML = box.dataset.kpLinenOriginalHtml;
        box.dataset.base = box.dataset.kpLinenOriginalBase;
        box.dataset.mins = box.dataset.kpLinenOriginalMins;
        box.dataset.discounts = box.dataset.kpLinenOriginalDiscounts;
      } else {
        const config = linenTierConfig(placement);
        const formatter = moneyFormatter();
        if (!formatter) return;
        const labels = config.mins.map((min, index) => (
          index === config.mins.length - 1 ? `${min}+` : `${min}\u2013${config.mins[index + 1] - 1}`
        ));
        list.replaceChildren(...labels.map((label, index) => {
          const row = document.createElement('li');
          const range = document.createElement('span');
          const amount = document.createElement('span');
          range.textContent = label;
          amount.className = 'kp-ladder__amt';
          amount.textContent = formatter.full(config.prices[index]);
          row.append(range, amount);
          return row;
        }));
        box.dataset.base = String(config.prices[0]);
        box.dataset.mins = config.mins.join(',');
        box.dataset.discounts = config.prices.map((price) => config.prices[0] - price).join(',');
      }

      const quantity = quantityFor(box);
      const mins = (box.dataset.mins || '').split(',').map((value) => Number.parseInt(value, 10));
      const prices = active ? linenTierConfig(placement).prices : null;
      let currentIndex = 0;
      mins.forEach((min, index) => { if (quantity >= min) currentIndex = index; });
      [...list.querySelectorAll('li')].forEach((row, index) => row.classList.toggle('is-active-tier', index === currentIndex));

      const message = box.querySelector('[data-kp-upsell]');
      if (!message) return;
      message.hidden = true;
      message.textContent = '';
      if (!active || !prices || currentIndex >= mins.length - 1) return;
      const nextIndex = currentIndex + 1;
      const currentTotal = quantity * prices[currentIndex];
      const nextTotal = mins[nextIndex] * prices[nextIndex];
      if (nextTotal >= currentTotal) return;
      const addCount = mins[nextIndex] - quantity;
      const template = message.dataset[addCount === 1 ? 'templateOne' : 'templateMany'];
      const formatter = moneyFormatter();
      if (!template || !formatter) return;
      message.textContent = template
        .replace('[count]', String(addCount))
        .replace('[savings]', formatter.full(currentTotal - nextTotal));
      message.hidden = false;
    });
  };

  const syncLinenOrderState = () => {
    const selection = window.__kpReadyLinenSelection;
    if (!selection) {
      clearLinenOrderState();
      return { active: false, enabled: true };
    }

    const placement = checkedOptionValue('Print Placement-');
    const variantId = window.__kpReadyLinenVariantIds?.[selection]?.[placement];
    const currency = window.Shopify?.currency?.active;
    const form = document.querySelector('main .product-information form[action*="/cart/add"]');
    const component = form?.closest('product-form-component');
    if (!form || !component || !variantId || currency !== 'CAD') {
      clearLinenOrderState();
      return { active: true, enabled: false, currency, placement, variantId };
    }

    form.dataset.kpVariantOverride = variantId;
    component.dataset.kpVariantOverride = variantId;
    component.dataset.kpReadyLinenActive = 'true';
    const title = document.querySelector('main h1')?.textContent?.trim() || productHandle();
    setLinenProperty(form, 'Ready design', `${title} (${productHandle()})`);
    setLinenProperty(form, 'Print color', checkedOptionValue('Print Color-'));
    return { active: true, enabled: true, currency, placement, variantId };
  };

  const applyLinenState = (picker, select) => {
    const orderState = syncLinenOrderState();
    const active = orderState.active;
    syncLinenLadder(active && orderState.currency === 'CAD', orderState.placement);
    document.querySelectorAll('main .product-information form[action*="/cart/add"] button[name="add"], main .sticky-add-to-cart__button').forEach((button) => {
      if (active && !orderState.enabled) {
        if (!button.dataset.kpLinenDisabled) button.dataset.kpPreviousDisabled = String(button.disabled);
        button.dataset.kpLinenDisabled = 'true';
        button.disabled = true;
      } else if (active && orderState.enabled) {
        if (!button.dataset.kpLinenDisabled) button.dataset.kpPreviousDisabled = String(button.disabled);
        button.dataset.kpLinenDisabled = 'true';
        button.disabled = false;
        button.setAttribute('aria-disabled', 'false');
      } else if (button.dataset.kpLinenDisabled) {
        button.disabled = button.dataset.kpPreviousDisabled === 'true';
        delete button.dataset.kpLinenDisabled;
        delete button.dataset.kpPreviousDisabled;
      }
    });
    let note = select.parentElement?.querySelector('.kp-linen-preview-note');
    if (!active || orderState.enabled) {
      note?.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'kp-linen-preview-note';
      note.setAttribute('role', 'status');
      select.after(note);
    }
    note.textContent = orderState.currency === 'USD'
      ? 'Linen Ready Design ordering is temporarily unavailable in USD while the double-sided USD price is finalized.'
      : 'This Linen placement is not available for ordering yet.';
  };

  const cleanup = () => {
    document.querySelectorAll('.kp-kippah-variant-clarity').forEach((root) => root.classList.remove('kp-kippah-variant-clarity'));
    document.querySelectorAll('.kp-kippah-options').forEach((fieldset) => fieldset.classList.remove('kp-kippah-options'));
    document.querySelectorAll('.kp-choice-prices').forEach((fieldset) => fieldset.classList.remove('kp-choice-prices'));
    document.querySelectorAll('.kp-variant-choice-price').forEach((price) => price.remove());
    document.querySelectorAll('.kp-kippah-select').forEach((select) => select.remove());
    document.querySelectorAll('.kp-linen-preview-note').forEach((note) => note.remove());
    document.querySelectorAll('[data-kp-linen-disabled]').forEach((button) => {
      button.disabled = button.dataset.kpPreviousDisabled === 'true';
      delete button.dataset.kpLinenDisabled;
      delete button.dataset.kpPreviousDisabled;
    });
  };

  const optionIndex = (input, fallback) => {
    const fieldsetIndex = Number.parseInt(input.dataset.fieldsetIndex, 10);
    if (Number.isInteger(fieldsetIndex)) return fieldsetIndex;
    const inputIdIndex = Number.parseInt(input.dataset.inputId?.split('-')[0], 10) - 1;
    return Number.isInteger(inputIdIndex) ? inputIdIndex : fallback;
  };

  const productData = (url) => {
    if (!productCache.has(url)) {
      productCache.set(url, fetch(`${url}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal
      }).then((response) => {
        if (!response.ok) throw new Error(`Product data request failed: ${response.status}`);
        return response.json();
      }).catch(() => null));
    }
    return productCache.get(url);
  };

  const moneyFormatter = () => {
    const currency = window.Shopify?.currency?.active;
    if (!currency) return null;
    try {
      const locale = document.documentElement.lang || undefined;
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      });
      const digits = formatter.resolvedOptions().maximumFractionDigits;
      const incrementFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: digits
      });
      const scale = 10 ** digits;
      return {
        full: (minorUnits) => formatter.format(minorUnits / scale),
        increment: (minorUnits) => incrementFormatter.format(minorUnits / scale)
      };
    } catch {
      return null;
    }
  };

  const quantityFor = (picker) => {
    const section = picker.closest('.shopify-section, dialog') || document;
    const value = Number.parseInt(section.querySelector('input[name="quantity"]')?.value, 10);
    return Number.isInteger(value) ? value : 10;
  };

  const tierPrice = (basePrice, kippah, quantity) => {
    const currency = window.Shopify?.currency?.active;
    const isLined = /^(?:Lined|Linen)\b/i.test(kippah);
    const thresholds = [10, 30, 60, 100];
    const cadDiscounts = isLined ? [0, 50, 100, 150] : [0, 100, 200, 250];
    const usdDiscounts = isLined ? [0, 50, 50, 100] : [0, 50, 150, 200];
    let tierIndex = 0;
    thresholds.forEach((threshold, index) => { if (quantity >= threshold) tierIndex = index; });
    let discount = currency === 'USD' ? usdDiscounts[tierIndex] : cadDiscounts[tierIndex];
    if (currency !== 'CAD' && currency !== 'USD') {
      const rate = Number.parseFloat(window.Shopify?.currency?.rate);
      if (!Number.isFinite(rate) || rate <= 0) return basePrice;
      discount = Math.round(discount * rate);
    }
    return Math.max(0, basePrice - discount);
  };

  const annotatePicker = async (picker) => {
    const url = picker.dataset.productUrl || window.location.pathname;
    const [product, linenProduct, formatMoney] = await Promise.all([
      productData(url),
      productData('/products/baby-blue-linen-kippah'),
      Promise.resolve(moneyFormatter())
    ]);
    if (!product?.variants?.length || !formatMoney || !picker.isConnected || !isKippahProduct()) return;

    const fieldsets = [...picker.querySelectorAll('fieldset.variant-option')];
    const selected = [];
    fieldsets.forEach((fieldset, fallbackIndex) => {
      const input = fieldset.querySelector('input[type="radio"]');
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      fieldset.classList.remove('kp-choice-prices');
      fieldset.querySelectorAll('.kp-variant-choice-price').forEach((price) => price.remove());
      fieldset.querySelectorAll('.kp-kippah-select').forEach((select) => select.remove());
      if (input && /kippah/i.test(fieldset.querySelector('legend')?.textContent || input.name)) fieldset.classList.add('kp-kippah-options');
      if (checked) selected[optionIndex(checked, fallbackIndex)] = checked.value;
    });

    fieldsets.forEach((fieldset, fallbackIndex) => {
      const labels = [...fieldset.querySelectorAll(':scope > .variant-option__button-label')];
      if (!labels.length) return;
      const firstInput = labels[0]?.querySelector('input[type="radio"]');
      const optionName = `${fieldset.querySelector('legend')?.textContent || ''} ${firstInput?.name || ''}`;
      const isKippah = /kippah/i.test(optionName);
      const isPlacement = /print placement|where would you like us to print/i.test(optionName);
      if (!isKippah && !isPlacement) return;

      const choices = labels.map((label) => {
        const input = label.querySelector('input[type="radio"]');
        const text = label.querySelector('.variant-option__button-label__text');
        if (!input || !text) return null;
        const index = optionIndex(input, fallbackIndex);
        const matchingValue = product.variants.filter((variant) => variant.options?.[index] === input.value);
        const exact = matchingValue.filter((variant) => selected.every((value, selectedIndex) => (
          selectedIndex === index || !value || variant.options?.[selectedIndex] === value
        )));
        return { label, text, exact, matchingValue };
      }).filter(Boolean);

      const addAnnotation = ({ text }, value) => {
        const annotation = document.createElement('span');
        annotation.className = 'kp-variant-choice-price';
        annotation.setAttribute('aria-hidden', 'true');
        annotation.textContent = value;
        text.after(annotation);
      };

      if (isKippah) {
        const select = document.createElement('select');
        select.className = 'kp-kippah-select';
        select.setAttribute('aria-label', 'Kippah');
        const quantity = quantityFor(picker);
        choices.forEach((choice) => {
          const candidates = choice.exact.length ? choice.exact : choice.matchingValue;
          const available = candidates.filter((variant) => variant.available);
          const priced = available.length ? available : candidates;
          const prices = [...new Set(priced.map((variant) => variant.price).filter(Number.isFinite))].sort((a, b) => a - b);
          const input = choice.label.querySelector('input[type="radio"]');
          if (!input || !prices.length) return;
          const option = document.createElement('option');
          option.value = input.value;
          option.textContent = `${input.value} — From ${formatMoney.full(tierPrice(prices[0], input.value, quantity))}`;
          option.selected = input.checked && !window.__kpReadyLinenSelection;
          option.disabled = input.disabled || !available.length;
          select.append(option);
        });
        const linenPrices = (linenProduct?.variants || [])
          .filter((variant) => variant.available && variant.options?.includes('Outside Print'))
          .map((variant) => variant.price)
          .filter(Number.isFinite)
          .sort((a, b) => a - b);
        if (linenPrices.length && window.__kpReadyLinenCatalog) {
          const linenGroup = document.createElement('optgroup');
          linenGroup.label = 'Linen';
          Object.keys(window.__kpReadyLinenCatalog).forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = `${value} - From ${formatMoney.full(linenTierPrice(quantity))}`;
            option.selected = window.__kpReadyLinenSelection === value;
            linenGroup.append(option);
          });
          select.append(linenGroup);
        }
        if (!select.options.length) return;
        select.addEventListener('change', () => {
          if (window.__kpReadyLinenCatalog?.[select.value]) {
            window.__kpReadyLinenSelection = select.value;
            document.documentElement.dataset.kpReadyLinenSelection = select.value;
            document.documentElement.dataset.kpReadyLinenProduct = productHandle();
            const linedInput = [...fieldset.querySelectorAll('input[type="radio"]')]
              .find((candidate) => candidate.value === 'Lined White' && !candidate.disabled);
            if (linedInput && !linedInput.checked) linedInput.click();
            applyLinenState(picker, select);
            document.dispatchEvent(new CustomEvent('kp:ready-linen-selection', { detail: { value: select.value } }));
            document.dispatchEvent(new CustomEvent('kp:preview-refresh'));
            return;
          }
          window.__kpReadyLinenSelection = '';
          delete document.documentElement.dataset.kpReadyLinenSelection;
          delete document.documentElement.dataset.kpReadyLinenProduct;
          const input = [...fieldset.querySelectorAll('input[type="radio"]')]
            .find((candidate) => candidate.value === select.value);
          if (!input || input.disabled) return;
          if (!input.checked) input.click();
          applyLinenState(picker, select);
          document.dispatchEvent(new CustomEvent('kp:ready-linen-selection', { detail: { value: '' } }));
          document.dispatchEvent(new CustomEvent('kp:preview-refresh'));
        }, { signal });
        fieldset.append(select);
        applyLinenState(picker, select);
        return;
      }

      const placementChoices = choices.map((choice) => {
        const available = choice.exact.filter((variant) => variant.available);
        const prices = available.map((variant) => variant.price).filter(Number.isFinite);
        return prices.length ? { ...choice, price: Math.min(...prices) } : null;
      }).filter(Boolean);
      if (!placementChoices.length) return;
      const baseline = Math.min(...placementChoices.map((choice) => choice.price));
      const extras = placementChoices.filter((choice) => choice.price > baseline);
      if (!extras.length) return;
      fieldset.classList.add('kp-choice-prices');
      extras.forEach((choice) => {
        addAnnotation(choice, `+${formatMoney.increment(choice.price - baseline)}`);
      });
    });
  };

  const enhance = async () => {
    observer?.disconnect();
    try {
      const root = productRoot();
      if (!root || !isKippahProduct()) {
        cleanup();
        return;
      }
      root.classList.add('kp-kippah-variant-clarity');
      await Promise.all([...root.querySelectorAll('variant-picker')].map(annotatePicker));
    } finally {
      observer?.observe(document.body, { childList: true, subtree: true });
    }
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(enhance, 60);
  };

  document.addEventListener('change', schedule, { capture: true, signal });
  document.addEventListener('quantity-selector:update', schedule, { signal });
  document.addEventListener('variant:update', schedule, { capture: true, signal });
  document.addEventListener('shopify:section:load', schedule, { signal });
  window.addEventListener('popstate', schedule, { signal });
  window.addEventListener('pageshow', schedule, { signal });

  const destroy = () => {
    controller.abort();
    observer?.disconnect();
    window.clearTimeout(timer);
    cleanup();
    window.__kpReadyLinenSelection = document.documentElement.dataset.kpReadyLinenSelection || '';
    style.remove();
    if (window.__kpKippahVariantClarity?.destroy === destroy) delete window.__kpKippahVariantClarity;
  };

  observer = new MutationObserver((records) => { if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches('media-gallery,kp-print-content,variant-picker') || node.querySelector('media-gallery,kp-print-content,variant-picker'))))) schedule(); });
  observer.observe(document.body, { childList: true, subtree: true });
  window.__kpKippahVariantClarity = { destroy };
  schedule();
})();
